import type { ComponentProps } from "react"
import { SelectLabel as SelectLabelBase } from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectLabelProps = ComponentProps<typeof SelectLabelBase>

function SelectLabel(props: SelectLabelProps) {
  const { className, ...selectLabelBaseProps } = props
  return (
    <SelectLabelBase
      className={cn("ui-select-label", className)}
      {...selectLabelBaseProps}
    />
  )
}

export default SelectLabel
